/**
 * Draft System Initialization Plugin
 *
 * This plugin initializes the draft store and performs cleanup of expired drafts
 * when the application starts on the client side.
 *
 * Features:
 * - Automatic cleanup of expired drafts on app load
 * - Runs only on client side
 * - Uses default TTL of 7 days
 */

export default defineNuxtPlugin(() => {
  // Only run on client side
  if (import.meta.client) {
    const draftStore = useDraftStore()
    
    // Clean expired drafts on app initialization
    draftStore.cleanExpiredDrafts()
  }
})
